import { combineReducers } from 'redux'
import bookingFlow from "./metadata/bookingFlow"
import signin from "./metadata/signin"
import signup from "./metadata/signup"
import forgotPassword from "./metadata/forgotPassword"
import auth from "./metadata/auth"
import createAccount from "./metadata/createAccount"
import accountProfile from "./metadata/accountProfile"
import accountSecurity from "./metadata/accountSecurity"
import residences from "./metadata/residences"
import bookings from "./metadata/bookings"
import booking from "./metadata/booking"
import userAffiliate from "./metadata/userAffiliate"

export const metadataReducer = combineReducers({
	bookingFlow,
	signin,
	signup,
	forgotPassword,
	accountProfile,
	accountSecurity,
	auth,
	createAccount,
	residences,
	bookings,
	booking,
	userAffiliate,
})



// WEBPACK FOOTER //
// ./src/reducers/metaData.js